import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-camera-1x1",
  "use": "icon-camera-1x1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-camera-1x1\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 0m32 0l960 0q32 0 32 32l0 960q0 32-32 32l-960 0q-32 0-32-32l0-960q0-32 32-32Z\" p-id=\"8418\" fill=\"#3da7e3\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/camera-1x1.svg
// module id = n78i
// module chunks = 250